import { SurveyReview } from "../../models/review/survey_review";
import { AnswerByType } from "../../models/review/answer_by_type";
export default {
    surveyReview: state => new SurveyReview(state.surveyReview),
    googleReview: state => new SurveyReview(state.googleReview),
    staffRatingAnswerList: state => {
        let data = state.staffRatingAnswerList;
        let result = {
            store: null,
            service: null
        };
        for(let i = 0; i < data.length; i++) {
            // result.push(new AnswerByType(data[i]));
            if(data[i].type == 'store') {
                result.store = new AnswerByType(data[i]);
            } else {
                result.service = new AnswerByType(data[i]);
            }
        }
        return result;
    },
    deviceList: state => state.deviceList,
    reviewData: state => state.reviewData,
    reviewReport: state => state.reviewReport,
    reviewList: state => state.reviewList,
    reviewListByType: state => type => {
        if(type == 'all') {
            return state.reviewList;
        } else if(type == 'google') {
            return state.reviewList.filter(review => (review.type == type || review.type == 'google_gmb'));
        } else {
            return state.reviewList.filter(review => review.type == type);
        }
    },
    reviewListByUser: state => user_id => {
        return state.reviewList.filter(review => (review.user_id == user_id && review.type == 'gocheckin'));
    },
    chartOptions: state => state.chartOptions,
    allReviewListData: state => state.allReviewListData,
    gocheckinReviewListData: state => state.gocheckinReviewListData,
    yelpReviewListData: state => state.yelpReviewListData,
    googleReviewListData: state => state.googleReviewListData,
    messageListData: state => state.messageListData,
    staffRatingList: state => state.staffRatingList
}
